<template>
  <NuxtLayout name="default">
    <div class="news-detail-container">
      <ClientOnly>
        <div v-if="banner.length > 0">
          <div
            class="banner-tag"
            v-for="item in banner.slice(0, 1)">
            <a
              :href="item.link"
              target="_blank">
              <img
                :src="item.url"
                alt="banner"
                loading="lazy"
                class="banner-img" />
            </a>
          </div>
        </div>
      </ClientOnly>
      <div class="news_content">
        <div class="news_left">
          <div class="top_brand">
            <a
              href="/"
              :title="$t('common.site_title')"
              target="_blank">
              {{ $t('menu.home') }}
            </a>
            <ArrowRight />
            <a
              href="/information/"
              :title="$t('menu.exhibitionInfo')"
              target="_blank">
              {{ $t('menu.exhibitionInfo') }}
            </a>
            <template v-if="$get(detail, 'industryId', 0)">
              <ArrowRight />
              <a
                :href="`/information-${detail.newsType || 0}-${$get(detail, 'industryId', 0)}-1/`"
                :title="detail.industryName + $t('news.information')"
                target="_blank">
                {{ detail.industryName + $t('news.information') }}
              </a>
            </template>
            <ArrowRight />
            <span>{{ detail.newsName }}</span>
          </div>

          <h1 class="news_name">
            {{ detail.newsName }}
          </h1>
          <div class="news_date row-flex ac">
            <span class="source">
              {{ $t('news.source') }}: {{ detail.source || $t('common.site_title') }}
            </span>
            <span class="date">
              <!-- {{ $get(detail, 'createTime', '').slice(0, 16) }} -->
              {{ detail.publishTime || detail.createTime }}
            </span>
            <span class="look">
              <i class="el-icon-look" />
              {{ detail.views }}
            </span>
            <span class="tag">
              {{ $t('news.category') }}:
              <a
                :href="`/information-${detail.newsType}-${$get(detail, 'industryId', 0)}-1/`"
                :title="detail.industryName + $t('news.information')"
                target="_blank">
                {{ detail.industryName + $t('news.information') }}
              </a>
            </span>
          </div>

          <div class="follow">
            <div
              class="follow_btn"
              @click="handleAttention">
              {{ detail.focus ? $t('news.unfollowAction') : $t('news.followAction') }}
            </div>
            <div class="share">
              <span>{{ $t('news.shareAction') }}：</span>
              <i
                class="el-icon-wei"
                @click="handleShowMini"
                style="font-size: 30px; cursor: pointer">
                <!-- <vue-qr
                  :logo-src="require('@/assets/icon/wei.webp')"
                  :text="`${MINI_HOST}?newsId=${$route.params.id}`"
                  :size="180"
                  :margin="8"
                  style="border: 1px solid #d6d7de"
                /> -->
              </i>
              <i
                class="el-icon-QQ"
                style="font-size: 30px; cursor: pointer"
                @click="shareToqq"></i>
              <i
                class="el-icon-zone"
                style="font-size: 30px; cursor: pointer"
                @click="shareToQzone"></i>
            </div>
          </div>
          <!-- 资讯内容 -->
          <!--  -->
          <div>
            <!-- <article class="news_detail" v-html="xss(`${detail.content}${exhibitionHtmlStr}`,xssOptions) " /> -->
            <RichImgLazy
              :htmlContent="`${detail.content}${exhibitionHtmlStr}`"
              classTag="news_detail"></RichImgLazy>
          </div>
          <!-- <div
            id="pavilion_map"
            style="width: 363px; height: 295px; border: solid 1px #000"
          ></div> -->

          <ClientOnly>
            <template v-if="detail.exhibitionList && detail.exhibitionList.length > 0 && fairId">
              <div
                v-for="fair in detail.exhibitionList"
                :key="fair.id"
                class="news_easy_info">
                <div class="img_cont">
                  <nuxt-link
                    :to="`/exhibition/${fair.id}.html`"
                    :title="fair.exhibitionName"
                    target="_blank">
                    <img
                      :src="logoFilter(fair.logo)"
                      :alt="fair.exhibitionName"
                      class="not-watermark"
                      loading="lazy" />
                  </nuxt-link>
                </div>
                <div class="easy_info">
                  <div class="En">
                    <!--                <nuxt-link-->
                    <!--                  :to="`/exhibition/${fair.exhibitionId}.html`"-->
                    <!--                  :title="fair.exhibitionEnglishName"-->
                    <!--                  target="_blank"-->
                    <!--                >-->
                    {{ fair.exhibitionEnglishName }}
                    <!--                </nuxt-link>-->
                  </div>
                  <div class="name">
                    <nuxt-link
                      :to="`/exhibition/${fair.id}.html`"
                      :title="fair.exhibitionName"
                      target="_blank">
                      {{ fair.exhibitionName }}
                    </nuxt-link>
                  </div>
                  <div
                    class="date_range"
                    v-if="fair.dynamic == 0">
                    {{ fair.lunchTime }}
                  </div>
                  <div
                    class="date_range"
                    v-else>
                    {{ fair.changeTime || fair.lunchTime }}
                  </div>
                  <div
                    v-if="fair.deadlineDays > 0"
                    class="left_over">
                    {{ $t('exhibitionDetail.distance') }}
                    <span class="num">{{ fair.deadlineDays }}</span>
                    {{ $t('exhibitionDetail.day') }}
                  </div>
                  <div
                    v-else-if="fair.deadlineDays === 0"
                    class="left_over"
                    style="font-size: 14px">
                    {{ $t('exhibitionDetail.exhibitionInProgress') }}
                  </div>
                  <div
                    v-else
                    class="left_over">
                    {{ $t('exhibitionDetail.nexttermTimeRenew') }}
                  </div>
                  <div class="but_box">
                    <div
                      class="but_but1"
                      @click="handleToPage('booth')">
                      {{ $t('exhibitionDetail.boothApply') }}
                    </div>
                    <div
                      class="but_but2"
                      @click="handleToPage('ticket')">
                      {{ $t('exhibitionDetail.ticketReservation') }}
                    </div>
                  </div>
                  <fair-tag
                    :exhibition-id="fairId"
                    style="margin-top: auto" />
                </div>
              </div>
            </template>
          </ClientOnly>
          <!-- <no-ssr>
            <div class="news_detail_banner">
              
              <div class="news_detail_banner_bg"></div>
            </div>
          </no-ssr> -->
          <div
            v-if="tag.length > 0"
            class="tag-box">
            <div class="tag-label">{{ $t('news.relatedTags') }}:</div>
            <div
              v-for="item in tag.slice(0, 10)"
              :key="item.id"
              class="tag">
              <nuxt-link
                :to="`/special/${item.id}.html`"
                :title="item.specialTopicName"
                target="_blank">
                {{ item.specialTopicName }}
              </nuxt-link>
            </div>
          </div>
          <div class="statement">{{ $t('news.copyrightStatement') }}</div>
          <div class="laiyuan">
            {{ $t('news.source') }}：{{ detail.source || $t('common.site_title') }}
            <!--          <span style="margin-left: 60px">扫一扫，关注我们</span>-->
          </div>
          <div class="follow">
            <ClientOnly>
              <media-box />
            </ClientOnly>

            <div
              class="follow_btn"
              @click="handleAttention">
              <i class="el-icon-zan"></i>
              {{ detail.focus ? $t('news.unlikeAction') : $t('news.likeAction') }}
            </div>
            <div class="share">
              <span>{{ $t('news.shareAction') }}：</span>
              <i
                class="el-icon-wei"
                style="font-size: 30px">
                <ClientOnly>
                  <VueQr
                    :logo-src="wei"
                    :text="`${MINI_HOST}?newsId=${id}`"
                    :size="180"
                    :margin="8"
                    style="border: 1px solid #d6d7de" />
                </ClientOnly>
              </i>
              <i
                class="el-icon-QQ"
                style="font-size: 30px"
                @click="shareToqq"></i>
              <i
                class="el-icon-zone"
                style="font-size: 30px"
                @click="shareToQzone"></i>
            </div>
          </div>
          <div
            v-if="fairId"
            class="enter-box">
            <div
              class="enter-btn"
              @click="handleToPage('booth')">
              {{ $t('exhibitionDetail.boothConsult') }}
            </div>
            <div
              class="enter-btn"
              @click="handleToPage('ticket')">
              {{ $t('exhibitionDetail.ticketReservation') }}
            </div>
            <div
              class="enter-btn"
              @click="handleToPage('periodical')">
              {{ $t('exhibitionDetail.exhibitorDirectory') }}
            </div>
          </div>
        </div>

        <div class="news_right">
          <!--          <ApplyBoothCard-->
          <!--              title="展位咨询"-->
          <!--              :fair-id="fairId"-->
          <!--              type="booth"-->
          <!--              submit-text="咨询"-->
          <!--          />-->
          <div v-if="detail.exhibitionList && detail.exhibitionList.length && fairId">
            <div
              class="relatedExhibition"
              v-for="item in [detail.exhibitionList[0]]"
              :key="item.id">
              <div class="exhibition_box">
                <nuxt-link
                  :to="`/exhibition/${item.id}.html`"
                  :title="item.exhibitionName"
                  target="_blank">
                  <img
                    :src="logoFilter(item.logo)"
                    :alt="item.exhibitionName"
                    class="exhibition_img" />
                </nuxt-link>

                <div class="relatedExhibitionName">
                  <nuxt-link
                    :to="`/exhibition/${item.id}.html`"
                    :title="item.exhibitionName"
                    target="_blank">
                    {{ item.exhibitionName }}
                  </nuxt-link>
                </div>
                <div class="relatedExhibitionEn">
                  {{ item.exhibitionEnglishName }}
                </div>
                <div class="exhibition_time">
                  {{ lunchTime(item) }}
                </div>
              </div>
              <div class="read_buy_content2">
                <div class="left">
                  <div
                    class="application_btn"
                    @click="handleToPage('booth')">
                    <div>
                      {{ $t('exhibitionDetail.boothApply') }}
                    </div>
                    <img src="~/assets/images/button_back.webp" />
                  </div>
                </div>
                <div class="right column-flex">
                  <div
                    class="btn"
                    @click="handleToPage('ticket')">
                    <div class="bg">
                      {{ $t('exhibitionDetail.ticketReservation') }}
                    </div>
                  </div>
                  <div
                    class="btn"
                    @click="handleToPage('periodical')">
                    <div class="bg">
                      {{ $t('exhibitionDetail.exhibitorPeriodical') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="boothServiceList.length">
            <div class="boothServiceBox">
              <div class="server-area">
                <div class="notice_tit">
                  <span>
                    {{ $t('customerService.boothSale') }}
                  </span>
                </div>
                <div
                  v-for="item in boothServiceList"
                  :key="item.id"
                  class="server">
                  <div class="server-left">
                    <div class="server-icon">
                      <img
                        v-lazy="getWebp(item.avatar)"
                        :alt="item.nickName"
                        rel="nofollow,noindex" />
                    </div>
                    <div class="server-info">
                      <div class="server-name">
                        {{ item.nickName }}
                      </div>
                      {{ item.postTitleName }}
                    </div>
                  </div>
                  <div class="server-btn">
                    <a
                      href="JavaScript:KS.openDirChatWin()"
                      rel="nofollow,noindex">
                      <i class="el-icon-evaluate" />
                      {{ $t('customerService.onlineContact') }}
                    </a>
                  </div>
                  <div class="service-other">
                    <div class="service-tel">
                      <div
                        v-if="item.companyPhone"
                        class="service-tel2">
                        {{ $t('customerService.telephone') }}
                        {{ item.companyPhone }}
                      </div>
                      <client-only>
                        <div
                          v-if="item.companyMobile"
                          class="service-tel2">
                          {{ $t('customerService.mobilePhone') }}
                          {{ item.companyMobile }}
                        </div>
                      </client-only>
                    </div>
                    <div
                      class="service-qrcode"
                      style="margin: 8px 0 8px 0">
                      <span>
                        {{ $t('customerService.wechat') }}
                      </span>
                      <img
                        class="wechat-icon"
                        src="~/assets/icon/wei2.webp
                        "
                        alt="wechat"
                        rel="nofollow,noindex" />
                      <div class="qrcode-area">
                        <img
                          class="qrcode"
                          :src="item.companyWxQr"
                          alt="wechat"
                          rel="nofollow,noindex" />
                      </div>
                    </div>
                  </div>
                </div>
                <div style="font-size: 14px">
                  <!-- <p>联系电话: </p> -->
                  <p>
                    {{ $t('customerService.workTime') }}: {{ $t('footer.work_time2') }} 09:00-18:00
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            class="more_exh"
            v-if="detail.industryName">
            <div class="aside-header">
              <SectionTitle
                :title="`${$get(detail, 'industryName', '')}${$t('news.industryExhibitions')}`"
                style="font-size: 18px" />
            </div>
            <div class="eve-fair">
              <div
                v-for="item in $get(fair, 'records', [])"
                :key="item.exhibitonId"
                class="eve-fair-item">
                <div class="fair-cover">
                  <nuxt-link
                    :to="`/exhibition/${item.exhibitionId}.html`"
                    :title="item.exhibitionName"
                    target="_blank">
                    <img
                      :src="logoFilter(item.pic)"
                      :alt="item.exhibitionName"
                      class="not-watermark"
                      loading="lazy" />
                  </nuxt-link>
                </div>
                <div class="fair-info">
                  <div class="fair-info-name">
                    <nuxt-link
                      :to="`/exhibition/${item.exhibitionId}.html`"
                      :title="item.exhibitionName"
                      target="_blank">
                      {{ item.exhibitionName }}
                    </nuxt-link>
                  </div>
                  <div
                    style="margin: 2px 0 2px 0"
                    v-if="item.dynamic == 0">
                    {{ item.lunchTime }}
                  </div>
                  <div
                    style="margin: 2px 0 2px 0"
                    v-else>
                    {{ item.changeTime || item.lunchTime }}
                  </div>
                  <div class="fair-info-name english">
                    {{ item.exhibitionEnglishName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="news_content"
        v-if="relatNew && relatNew.length > 0">
        <div class="news_left">
          <div class="relateNews">
            <div class="relateNews_title">{{ $t('news.relatedUpdates') }}</div>
            <div class="relateNew_box">
              <div
                class="relateNew_detail"
                v-for="item in relatNew">
                <span @click="toNewDetail(item.viewUrl, item.newsId)">
                  {{ item.newsName }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="news.length > 0"
        class="news-area">
        <div class="news-header-area">
          <SectionTitle
            h2
            class="news-header"
            :title="`${detail.industryName}${$t('news.industryNews')}`" />
        </div>
        <div class="exh_news_container">
          <div class="news_left">
            <div class="news-cover">
              <nuxt-link
                :to="handleNewsUrl($get(news, '[0].viewUrl', ''), $get(news, '[0].newsId', ''))"
                :title="$get(news, '[0].newsName', '')"
                target="_blank">
                <img
                  :src="$get(news, '[0].logo', '')"
                  :alt="$get(news, '[0].newsName', '')"
                  loading="lazy" />
              </nuxt-link>
            </div>
            <div class="news_info">
              <p class="name">
                <i
                  style="width: 24px"
                  class="el-icon-toutiao"></i>
                <span>
                  <nuxt-link
                    :to="handleNewsUrl($get(news, '[0].viewUrl', ''), $get(news, '[0].newsId', ''))"
                    :title="$get(news, '[0].newsName', '')"
                    target="_blank">
                    {{ $get(news, '[0].newsName', '') }}
                  </nuxt-link>
                </span>
              </p>
              <p class="time">
                <span style="margin-right: 15px">
                  {{ $get(news, '[0].createTime', '') }}
                </span>
                <i
                  style="width: 12px; margin-right: 4px"
                  class="el-icon-look"></i>
                <span>{{ $get(news, '[0].views', 0) }}</span>
              </p>
              <div class="content">
                {{ description($get(news, '[0]', {})) }}
              </div>
            </div>
          </div>
          <div class="right_left">
            <ul>
              <li
                v-for="item in news.slice(1)"
                :key="item.newsId">
                <span class="red_dot"></span>
                <span class="sub_tit">
                  <nuxt-link
                    :to="handleNewsUrl(item.viewUrl, item.newsId)"
                    :title="item.newsName"
                    target="_blank">
                    {{ item.newsName }}
                  </nuxt-link>
                </span>
                <i
                  style="width: 12px"
                  class="el-icon-look"></i>
                <span class="look">{{ item.views }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--相关文章-->
      <div
        v-if="false"
        class="news-area">
        <div class="news-header-area">
          <SectionTitle
            h2
            class="news-header"
            :title="$t('news.relatedUpdates')" />
        </div>
        <div class="news-list">
          <RelatedNew
            v-for="item in tagNews"
            :key="item.id"
            :news="item" />
        </div>
      </div>
      <div class="hot_country">
        <div class="tab_head row-flex">
          <div
            class="tab_name"
            :class="{ active: innerChainActive == 0 }"
            @click="handleHotTab(0)">
            热门地区
          </div>
          <div
            class="tab_name"
            :class="{ active: innerChainActive == 1 }"
            @click="handleHotTab(1)">
            热门行业
          </div>
          <div
            class="tab_name"
            :class="{ active: innerChainActive == 2 }"
            @click="handleHotTab(2)">
            热门展会
          </div>
        </div>
        <div class="country_list">
          <div
            class="tab_content row-flex-wrap"
            v-show="innerChainActive == 0">
            <a
              v-for="item in innerChainAreaList"
              :key="item.id"
              :href="item.url"
              target="_blank"
              :title="item.content">
              {{ item.content }}
            </a>
          </div>
          <div
            class="tab_content row-flex-wrap"
            v-show="innerChainActive == 1">
            <a
              v-for="item in innerChainIndustryList"
              :key="item.id"
              :href="item.url"
              target="_blank"
              :title="item.content">
              {{ item.content }}
            </a>
          </div>
          <div
            class="tab_content row-flex-wrap"
            v-show="innerChainActive == 2">
            <a
              v-for="item in innerChainExhList"
              :key="item.id"
              :href="item.url"
              target="_blank"
              :title="item.content">
              {{ item.content }}
            </a>
          </div>
        </div>
      </div>

      <el-dialog
        destroy-on-close
        append-to-body
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        v-model="dialogShow"
        :title="dialogTitle"
        width="400px"
        class="preview-component">
        <img
          :src="dialogImg"
          :alt="dialogTitle"
          loading="lazy" />
        <div class="desc">{{ $t('news.wechatScanPrompt') }}</div>
      </el-dialog>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
  import xss from 'xss'
  import { xssOptions } from '~/utils/lazyImg'
  import _ from 'lodash'
  import { handleNewsUrl, MINI_HOST, getWebp } from '~/utils/common'
  // import { blackList } from '~/utils/blackFair'
  import { logoFilter } from '~/filters'
  import wei from '~/assets/icon/wei.webp'
  import { useNewsDetails } from '~/composables/news/useNewsDetails'
  import { ArrowRight } from '@element-plus/icons-vue'
  import { ELocale } from '~~/types/enums'
  import { fa } from 'element-plus/es/locales.mjs'
  import { onMounted, nextTick, watch } from 'vue'

  const SectionTitle = defineAsyncComponent(() => import('~/components/SectionTitle/index.vue'))
  // @ts-ignore
  const VueQr = defineAsyncComponent(() => import('vue-qr/src/packages/vue-qr.vue'))
  const FairTag = defineAsyncComponent(() => import('~/components/Goods/fairTag.vue'))
  const MediaBox = defineAsyncComponent(() => import('~/components/MediaBox/index.vue'))
  const NewsItem = defineAsyncComponent(() => import('~/pages/news/components/NewsItem.vue'))
  // const ApplyBoothCard = defineAsyncComponent(() => import('~/pages/booth/components/card.vue'));
  const RelatedNew = defineAsyncComponent(() => import('~/pages/news/components/RelatedNew.vue'))
  const RichImgLazy = defineAsyncComponent(() => import('~/components/richImgLazy/index.vue'))
  import { onErrorCaptured } from 'vue'
  onErrorCaptured((err, instance, info) => {
    console.error('onErrorCaptured 2678:', err, info)
    // 返回 false 阻止错误继续向上传递
    return false
  })

  const {
    $get,
    id,
    detail,
    fair,
    news,
    newNews,
    tag,
    tagNews,
    banner,
    relatNew,
    sourceResult,
    innerChainActive,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    dialogShow,
    dialogTitle,
    dialogImg,
    lunchTime,
    description,
    fairId,
    exhibitionHtmlStr,
    initMap,
    handleHotTab,
    getAndCount,
    fetchLinks,
    handleShowMini,
    toNewDetail,
    getBanner,
    shouldLogin,
    handleAttention,
    shareToQzone,
    shareToqq,
    handleToPage,
    boothServiceList
  } = await useNewsDetails(ELocale.cn)
  const route = useRoute()

  useHead(() => {
    const reg = /<[^>]+>/gi
    let description1 = _.get(detail, 'description', '')
    const _description1 = description1
      ? description1
          ?.replace(reg, '')
          ?.replace(/&nbsp;/g, '')
          .trim()
      : ''
    let description2 = _.get(detail, 'content', '')
    const _description2 = description2
      ? description2
          ?.replace(reg, '')
          ?.replace(/&nbsp;/g, '')
          .trim() || ''
      : ''
    let keywords = ``
    let firstExhibition = null
    if (detail.value.exhibitionList && detail.value.exhibitionList.length > 0) {
      firstExhibition = detail.value.exhibitionList[0]
      keywords = `${firstExhibition.exhibitionName},${
        firstExhibition.exhibitionEnglishName
      },${firstExhibition.area || ''}${detail.value.industryName || ''}`
    }
    let exStr =
      firstExhibition?.area && detail.value.industryName
        ? `${firstExhibition?.area || ''}${detail.value.industryName || ''}展`
        : ''

    return {
      title: `${detail.value.newsName}-聚展`, // `${detail.newsName}-${exStr}-聚展`
      script: [
        {
          // src: `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=o45POEHHUGPtwV2I3yT1xUEi`
        }
      ],
      meta: [
        {
          name: 'mobile-agent',
          'http-equiv': 'mobile-agent',
          content: `format=html5; url=https://m.jufair.com/information/${detail.value.id}.html`
        },
        {
          name: 'keywords',
          content: keywords
        },
        {
          name: 'description',
          content: _description1 || _description2 //.slice(0, 100),
        },
        {
          name: 'og:type',
          content: 'article'
        },
        {
          name: 'og:url',
          content: `https://www.jufair.com${route.fullPath}`
        },
        {
          name: 'og:title',
          content: detail.value.newsName
        },
        {
          name: 'og:release_date',
          content: detail.value.createTime
        },
        {
          name: 'og:image',
          content: detail.value.logo
        },
        {
          name: 'og:description',
          content: _description1 || _description2 //_description.slice(0, 100),
        }
      ]
    }
  })
</script>

<style lang="less" scoped>
  .news_detail {
    margin: 16px 0;
    font-size: 18px;
    font-family:
      PingFang SC,
      Hiragino Sans GB,
      Microsoft YaHei,
      WenQuanYi Micro Hei,
      Helvetica Neue,
      Arial,
      sans-serif;
    line-height: 1.667;
    color: #222;

    :deep(img) {
      display: block;
      margin: 0 auto;
      width: 650px !important;
      border-radius: 4px;
    }

    :deep(img[lazy='error']) {
      display: none;
    }

    // div,
    :deep(p),
    :deep(section) {
      margin-top: 13px;
      margin-bottom: 16px;
      text-align: justify;
    }

    // strong {
    //   font-weight: 400;
    // }

    :deep(a) {
      color: @app-color;
      text-decoration: underline;
    }

    :deep(.box_name) {
      margin: 10px 0;
      text-align: center;
      color: #487ef1;
      font-size: 20px;
    }

    :deep(.exhibition_table) {
      width: 100%;
      border: 1px solid #333;
      border-collapse: collapse;
      /* 移除单元格之间的间隔 */
      margin-bottom: 15px;

      tbody {
        th,
        td {
          padding: 5px 5px;
          text-align: center;
          border: 1px solid #ddd;
          border-collapse: collapse;
          /* 移除单元格之间的间隔 */
        }

        th {
          font-weight: normal;
          // color: #fff;
          // background: #487ef1;
          font-size: 16px !important;
        }

        td {
          color: #666;
          font-size: 16px !important;

          a {
            color: #487ef1;
            text-decoration: unset;
          }

          .button {
            display: none;
          }
        }
      }
    }
  }

  // 展馆图片,地图样式
  .pavilion {
    font-size: 16px;
    color: #666;
    line-height: 28px;
    // margin-bottom: 36px;
    margin-top: 14px;

    .pavilion_name {
      font-weight: bold;
      color: #333;

      .info-item_but {
        margin-left: 20px;
        padding: 6px 10px;
        border-radius: 5px;
        font-size: 14px;
        font-family:
          PingFangSC-Medium,
          PingFang SC,
          sans-serif;
        font-weight: 400;
        cursor: pointer;
        background: #e50113;
        color: #fff;
      }
    }

    .pavilion_address {
      margin-top: 10px;
    }

    .pavilion-area {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      .img_con {
        width: 390px;
        height: 297px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        transform: translateZ(0);
        overflow: hidden;

        img {
          // width: auto;
          width: 390px;
          min-width: 390px;
          height: 297px;
          border-radius: 6px;
          transform: translateZ(0);
        }
      }

      :deep(.el-carousel) {
        width: 390px;
        border-radius: 6px;
        transform: translateZ(0);
        overflow: hidden;
      }

      :deep(.pavilion_map) {
        width: 366px !important;
        height: 295px;
        transform: translateZ(0);

        &:only-child {
          width: 100%;
        }
      }
    }
  }

  // 攻略资讯
  .strategy-content {
    :deep(.fair-info) {
      .box-title {
        margin-top: 10px;
        font-size: 16px;
        font-weight: bold;
      }

      .content {
        a {
          color: @app-color;
        }
      }
    }

    :deep(.medium_item) {
      margin-top: 10px;

      img {
        max-width: 100%;
      }
    }
  }
</style>

<style lang="less" scoped>
  .news-detail-container {
    .banner-tag {
      width: 1190px;
      margin: 22px auto;

      > a {
        > img {
          width: 1190px;
          border-radius: 6px;
        }
      }
    }

    .news_content {
      width: 1190px;
      display: flex;
      margin: 15px auto 20px auto;

      .news_left {
        width: 854px;
        background: #fff;
        border-radius: 6px;
        padding: 20px 56px 20px 56px;
        margin-right: 12px;
        overflow: hidden;

        .top_brand {
          font-size: 14px;
          color: #333;
          line-height: 16px;
          // display: flex;

          svg {
            width: 14px;
          }
        }

        .news_name {
          font-family: MicrosoftYaHei-Bold, MicrosoftYaHei, sans-serif;
          font-size: 23px;
          font-weight: bold;
          color: #333;
          margin: 34px 0 16px;
          line-height: 36px;
        }

        .news_date {
          font-size: 14px;
          color: #999;
          margin-top: 7px;

          span {
            margin-right: 15px;
          }

          .look {
            display: inline-flex;

            .el-icon-look {
              margin-right: 4px;
            }
          }

          .tag {
            a {
              color: @app-color;
            }
          }
        }

        .news_easy_info {
          width: 100%;
          padding: 25px;
          display: flex;
          margin-top: 12px;
          border-radius: 6px;
          background: #f7f7f7;
          position: relative;

          .img_cont {
            width: 258px;
            height: 151px;
            border-radius: 6px;
            border: 1px solid #ddd;
            margin-right: 20px;
            flex-shrink: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;

            img {
              width: 258px;
              height: auto;
            }
          }

          .easy_info {
            display: flex;
            flex-direction: column;
            width: 440px;

            .En {
              font-size: 18px;
              font-weight: bold;
              color: #d63627;
            }

            .name {
              font-size: 16px;
              color: #333;
              line-height: 26px;
              letter-spacing: 1px;
              font-weight: bold;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }

            .date_range {
              font-size: 16px;
              color: #666;
              line-height: 22px;
              margin-bottom: 24px;
            }

            .left_over {
              font-size: 16px;
              color: #333;
              line-height: 19px;

              .num {
                color: #ff8600;
                font-size: 16px;
                font-weight: bold;
              }
            }

            .but_box {
              .but_but1,
              .but_but2 {
                width: 100px;
                text-align: center;
                position: absolute;
                background: #e50113;
                color: #fff;
                right: 25px;
                font-family:
                  PingFangSC-Medium,
                  PingFang SC,
                  sans-serif;
                font-size: 18px;
                font-weight: 400;
                border-radius: 4px;
                padding: 6px 10px;
                letter-spacing: 1px;
                cursor: pointer;
                bottom: 25px;
              }

              .but_but2 {
                bottom: 80px;
              }
            }
          }
        }

        .follow {
          display: flex;
          // justify-content: flex-end;
          align-items: flex-end;
          margin-top: 12px;

          .wechat-area {
            display: flex;

            .wechat-item {
              // border: 1px solid #ccc;
              border-radius: 4px;
              overflow: hidden;
              margin-right: 20px;

              img {
                width: 140px;
              }
            }
          }

          .follow_btn {
            margin-left: auto;
            display: inline-block;
            padding: 0 8px;
            height: 26px;
            background: #ebebeb;
            border-radius: 4px;
            font-size: 14px;
            color: #666;
            text-align: center;
            line-height: 26px;
            margin-right: 16px;
            cursor: pointer;

            &:hover {
              background: #d63627;
              color: #fff;
            }
          }

          .share {
            font-size: 14px;
            color: #333;
            display: flex;
            align-items: center;

            i {
              margin-right: 6px;
            }

            [class^='el-icon-'] {
              font-size: 24px;
              width: 24px;
            }

            .el-icon-wei {
              position: relative;

              &:hover {
                img {
                  display: inline-block !important;
                }
              }

              img {
                display: none !important;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%, 100%);
                z-index: 100;
              }
            }
          }
        }

        .enter-box {
          display: flex;
          gap: 8px;
          margin: 12px 0;

          .enter-btn {
            border-radius: 4px;
            background: @app-color;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 33.33%;
            height: 40px;
            cursor: pointer;
          }
        }

        .relateNews {
          margin-top: 6px;

          .relateNews_title {
            font-size: 24px;
            font-weight: 800;
            text-align: center;
            margin-bottom: 10px;
          }

          .relateNew_box {
            display: flex;
            flex-wrap: wrap;

            .relateNew_detail {
              position: relative;
              z-index: 2;
              width: 49%;
              margin: 14px 14px 0 0;
              border: 1px solid #fff;
              padding: 10px;
              border-radius: 4px;
              background-color: #c8e0ff;
              // border-color: #d9ecff;
              overflow: hidden;
              /* 隐藏溢出内容 */
              text-overflow: ellipsis;
              /* 使用省略号表示溢出的文本 */
              white-space: nowrap;
              /* 防止文本换行 */
              color: #333;
              cursor: pointer;

              &:nth-child(2n) {
                margin: 14px 0 0 0;
              }

              &::before {
                z-index: -1;
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 0%;
                height: 100%;
                background: #e50113;
                transition: all 0.3s ease-out 0s;
              }

              &:hover {
                color: #fff;

                &::before {
                  width: 100%;
                }
              }
            }
          }
        }

        .tag-box {
          display: flex;
          flex-wrap: wrap;
          margin: 10px 0;

          .tag-label {
            margin-right: 1em;
          }

          .tag {
            margin-right: 10px;

            a {
              color: @app-color;
            }
          }
        }

        .laiyuan {
          //margin-top: 10px;
          font-size: 16px;
          color: #666;
          line-height: 30px;
        }

        .statement {
          font-size: 14px;
          color: #9a9a9a;
          line-height: 2;
          padding: 10px 0;
        }

        .news_detail_banner {
          position: relative;

          img {
            max-width: 100%;
          }

          .news_detail_banner_bg {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 47px;
            background: #fff;
          }
        }
      }

      .news_right {
        width: 324px;
        flex-shrink: 0;

        .aside-header {
          // background: #fff;
          padding: 0 0 12px 0;
          display: flex;
          justify-content: space-between;
          align-items: baseline;

          .more {
            font-size: 14px;
          }
        }

        .relatedExhibition {
          width: 100%;
          min-height: 200px;
          background: #fff;
          padding: 15px;
          margin-bottom: 20px;

          .exhibition_box {
            .exhibition_img {
              display: block;
              margin: 0 auto;
              width: 292px;
              height: 173px;
              object-fit: cover;
            }

            .relatedExhibitionName {
              font-weight: bold;
              font-size: 20px;
              color: #333;
              margin: 10px 0 8px 0;
            }

            .relatedExhibitionEn {
              font-size: 20px;
              color: #333;
            }

            .exhibition_time {
              margin-top: 15px;
              font-size: 14px;
              color: #999;
            }
          }
        }

        .boothServiceBox {
          .server-area {
            margin: 12px 0;
            padding: 16px 19px 22px 17px;
            background: #fff;
            border-radius: 6px;

            .server {
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              margin-top: 16px;
              margin-bottom: 10px;
              font-size: 16px;

              .server-left {
                display: flex;
                flex-direction: row;

                .server-icon {
                  margin-right: 16px;
                }
              }

              .server-info {
                display: flex;
                flex-direction: column;
                justify-content: center;
                // align-items: center;

                .server-name {
                  font-size: 16px;
                }

                .server-pai {
                  color: #666;
                }
              }

              .server-btn {
                display: flex;
                align-items: baseline;
                cursor: pointer;

                a {
                  color: @app-color;
                }
              }

              img {
                width: 48px;
                height: 48px;
                border-radius: 50%;
              }
            }

            .service-other {
              margin-top: 10px;
              width: 100%;

              .service-tel {
                line-height: 24px;
                color: #e50113;
              }

              .service-qrcode {
                display: flex;
                align-items: center;
                margin: 0 40px 0 0;
                position: relative;
                font-size: 14px;

                span {
                  padding-right: 0.5em;
                }

                .wechat-icon {
                  cursor: pointer;
                  width: 32px;
                  height: 32px;

                  &:hover + .qrcode-area {
                    display: block;
                  }
                }

                .qrcode-area {
                  position: absolute;
                  background: #fff;
                  border: 1px solid #ccc;
                  border-radius: 4px;
                  z-index: 9;
                  display: none;
                  // bottom: -205px;
                  top: 43px;
                  left: 0;
                  transition: all 0.3s;
                  overflow: hidden;

                  .qrcode {
                    width: 150px;
                    min-height: 150px;
                    border-radius: 4px;
                  }
                }
              }
            }
          }
        }

        .news-list {
          .news-item {
            display: flex;
            background: #fff;
            margin-bottom: 8px;
            box-sizing: border-box;
            padding: 12px;
            border-radius: 4px;

            .news-cover {
              width: 108px;
              height: 70px;
              margin-right: 12px;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;
              flex-shrink: 0;

              img {
                width: 108px;
                height: auto;
              }
            }

            .news-info {
              width: calc(100% - 120px);
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .news-name {
                font-size: 14px;
                overflow: hidden; //将超出的部分隐藏
                text-overflow: ellipsis; //超出部分用省略号显示
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }

              .news-time {
                color: #666;
                font-family: 'Helvetica Neue', Helvetica, sans-serif;
                font-size: 14px;
              }
            }
          }
        }

        // .more_exh {
        //   background: #fff;
        //   border-radius: 6px;
        //   padding: 16px 15px;
        //   .exh_item:last-child {
        //     border: none;
        //   }
        // }
      }
    }

    .eve-fair {
      &-item {
        display: flex;
        padding: 13px 0;
        border-bottom: solid 1px #eaeaea;

        .fair-cover {
          width: 120px;
          height: 82px;
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 4px;
          overflow: hidden;
          margin-right: 10px;
          box-sizing: border-box;
          border: solid 1px #eaeaea;

          img {
            width: 120px;
            height: auto;
            min-height: 82px;
          }
        }

        .fair-info {
          font-size: 16px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 6px 0;

          &-name {
            color: #333;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;

            a {
              &:hover {
                color: @app-color;
              }
            }
          }

          .english {
            font-size: 14px;
            color: #666;
          }
        }
      }
    }

    .fair-area {
      width: 1190px;
      margin: 0 auto;

      .fair-header-area {
        padding: 10px 0 10px 0;
        // background: #fff;
        border-radius: 6px;

        .fair-header {
          font-size: 18px;
        }
      }

      .fair-list {
        display: flex;
        flex-wrap: wrap;

        .fair-item {
          margin-right: 12px;

          &:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
    }

    .news-area {
      width: 1190px;
      margin: 0 auto;

      .news-header-area {
        padding: 10px 0 10px 0;
        // background: #fff;
        border-radius: 6px;

        .news-header {
          font-size: 18px;
        }
      }
    }

    .exh_news_container {
      display: flex;
      margin-bottom: 22px;

      .news_left {
        width: 708px;
        padding: 24px 16px;
        margin-right: 12px;
        display: flex;
        align-items: center;
        background: #fff;
        border-radius: 6px;

        .news-cover {
          width: 236px;
          height: 138px;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          border: 1px solid #ddd;
          margin-right: 18px;
          border-radius: 4px;
          flex-shrink: 0;

          img {
            width: 236px;
            height: auto;
          }
        }

        .news_info {
          height: 100%;
          padding: 4px 0;

          .name {
            font-size: 16px;
            font-weight: bold;
            color: #333;
            width: 420px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .time {
            display: flex;
            font-size: 14px;
            color: #999;
            margin-top: 10px;
          }

          .content {
            margin-top: 18px;
            line-height: 24px;
            font-size: 14px;
            color: #666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 3; //显示的行
          }
        }
      }

      .right_left {
        flex: 1;
        background: #fff;
        border-radius: 6px;
        padding: 14px 20px;

        ul {
          display: flex;
          flex-flow: column;
          // justify-content: space-around;
          height: 100%;

          li {
            list-style: none;
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #555;
            margin-bottom: 11px;

            &:last-child {
              margin-bottom: 0;
            }

            .red_dot {
              display: inline-block;
              width: 4px;
              height: 4px;
              background: #e50113;
              margin-right: 7px;
            }

            .sub_tit {
              display: inline-block;
              width: 348px;
              overflow: hidden; //超出的文本隐藏
              text-overflow: ellipsis; //溢出用省略号显示
              white-space: nowrap;
              margin-right: 22px;
            }

            .look {
              color: #999;
              font-size: 14px;
              margin-left: 2px;
            }
          }
        }
      }
    }

    .hot_country {
      width: 1190px;
      margin: 16px auto;
      padding: 20px 39px;
      background: #fff;
      border-radius: 6px;

      .tab_head {
        gap: 10px 20px;
        margin-bottom: 10px;

        .tab_name {
          padding-bottom: 3px;
          font-size: 15px;
          border-bottom: solid 2px #fff;

          &.active {
            border-bottom: solid 2px @app-color;
          }

          &:hover {
            cursor: pointer;
          }
        }
      }

      .tab_content {
        gap: 10px;
      }

      .country_list {
        a {
          font-size: 15px;
          color: #333;
          min-width: 129px;
          // margin-right: 20px;
          // margin-bottom: 10px;

          &:nth-child(8n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  // 攻略资讯
  .strategy_content,
  #strategyContent {
    line-height: 32px;

    :deep(.fair-info) {
      .box-title {
        margin-top: 10px;
        font-size: 16px;
        font-weight: bold;
      }

      .content {
        a {
          color: @app-color;
        }
      }
    }

    :deep(.medium_item) {
      img {
        max-width: 100%;
      }
    }
  }

  .read_buy_content2 {
    background: #fff;
    border-radius: 6px;
    font-weight: 600;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 15px;

    .application_btn {
      width: 130px;
      height: 98px;
      opacity: 1;
      border-radius: 6px;
      background: linear-gradient(to right, #e50113, #fd7f42);
      font-weight: 500;
      letter-spacing: 0;
      line-height: 53px;
      color: #fff;
      cursor: pointer;
      display: flex;
      justify-items: center;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      transition: background-image 0.5s ease;

      img {
        width: 26px;
        margin-left: 3px;
      }

      &:hover {
        background: linear-gradient(90deg, #fd7f42, #e50113);
      }
    }

    .right {
      gap: 10px;
    }

    .btn {
      width: 152px;
      height: 44px;
      opacity: 1;
      border-radius: 6px;
      background: linear-gradient(to right, #e50113, #fd7f42);
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 44px;
      color: #fff;
      cursor: pointer;
      text-align: center;
      // padding-left: 15px;
      position: relative;
      overflow: hidden;

      .bg {
        // background: url('../../assets/images/button_back2.webp') 100px 10px no-repeat;
      }

      &:hover {
        cursor: pointer;
        background: linear-gradient(90deg, #fd7f42, #e50113);
      }
    }
  }
</style>
